var map = {
	"./1_after": 10,
	"./1_after.webp": 10,
	"./1_before": 11,
	"./1_before.webp": 11,
	"./apple-touch-icon-ipad-76x76": 12,
	"./apple-touch-icon-ipad-76x76.png": 12,
	"./apple-touch-icon-ipad-retina-152x152": 13,
	"./apple-touch-icon-ipad-retina-152x152.png": 13,
	"./apple-touch-icon-iphone-60x60": 14,
	"./apple-touch-icon-iphone-60x60.png": 14,
	"./apple-touch-icon-iphone-retina-120x120": 15,
	"./apple-touch-icon-iphone-retina-120x120.png": 15,
	"./banner01": 16,
	"./banner01.webp": 16,
	"./banner02": 17,
	"./banner02.webp": 17,
	"./banner03": 18,
	"./banner03.webp": 18,
	"./banner04": 19,
	"./banner04.webp": 19,
	"./banner04b": 20,
	"./banner04b.webp": 20,
	"./banner06": 21,
	"./banner06.jpg": 21,
	"./banner_calculator": 22,
	"./banner_calculator.webp": 22,
	"./bg_counseling": 23,
	"./bg_counseling.webp": 23,
	"./bg_diary": 24,
	"./bg_diary.webp": 24,
	"./bg_home": 25,
	"./bg_home.webp": 25,
	"./bg_recipes": 26,
	"./bg_recipes.webp": 26,
	"./bg_training": 27,
	"./bg_training.webp": 27,
	"./favicon": 28,
	"./favicon.png": 28,
	"./navbar_banner": 29,
	"./navbar_banner.webp": 29,
	"./overlay": 30,
	"./overlay.png": 30,
	"./pic01": 31,
	"./pic01.jpg": 31,
	"./pic02": 32,
	"./pic02.jpg": 32,
	"./pic03": 33,
	"./pic03.jpg": 33,
	"./pic04": 34,
	"./pic04.jpg": 34,
	"./pic08": 35,
	"./pic08.jpg": 35,
	"./preview_diary_1": 36,
	"./preview_diary_1.webp": 36,
	"./preview_diary_1_thumb": 37,
	"./preview_diary_1_thumb.webp": 37,
	"./preview_diary_2": 38,
	"./preview_diary_2.webp": 38,
	"./preview_diary_2_thumb": 39,
	"./preview_diary_2_thumb.webp": 39,
	"./preview_diary_3": 40,
	"./preview_diary_3.webp": 40,
	"./preview_diary_3_thumb": 41,
	"./preview_diary_3_thumb.webp": 41,
	"./preview_recipe_1": 42,
	"./preview_recipe_1.webp": 42,
	"./preview_recipe_1_thumb": 43,
	"./preview_recipe_1_thumb.webp": 43,
	"./preview_recipe_2": 44,
	"./preview_recipe_2.webp": 44,
	"./preview_recipe_2_thumb": 45,
	"./preview_recipe_2_thumb.webp": 45,
	"./preview_recipe_3": 46,
	"./preview_recipe_3.webp": 46,
	"./preview_recipe_3_thumb": 47,
	"./preview_recipe_3_thumb.webp": 47,
	"./preview_training_1": 48,
	"./preview_training_1.webp": 48,
	"./preview_training_1_thumb": 49,
	"./preview_training_1_thumb.webp": 49,
	"./preview_training_2": 50,
	"./preview_training_2.webp": 50,
	"./preview_training_2_thumb": 51,
	"./preview_training_2_thumb.webp": 51,
	"./slide1": 52,
	"./slide1.webp": 52,
	"./slide2": 53,
	"./slide2.webp": 53,
	"./slide3": 54,
	"./slide3.webp": 54,
	"./what_to_expect": 55,
	"./what_to_expect.jpg": 55,
	"./workout-preview": 56,
	"./workout-preview.webp": 56
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72;